import { request } from '@/services/request/request.api'

import { IHistoryResponse } from '@/types/history.interface'

export const HistoryService = {
	async getHistoryTasks(limit = 100) {
		return request<IHistoryResponse>({
			url: `/highlights/history?limit=${limit}`,
			method: 'GET'
		})
	}
}
